export default __webpack_public_path__ + "afbc71c68551023c86fbed965c043773.png";